import { getApiEndpoint } from '../config/api'
import { getAuthHeaders } from './auth'

// Enhance global fetch to attach Cognito ID token for API requests
// Only applies to requests targeting the configured API endpoint.
(function attachAuthToFetch() {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;

  const apiBase = (() => {
    try {
      const base = getApiEndpoint();
      return base.endsWith('/') ? base.slice(0, -1) : base;
    } catch {
      return '';
    }
  })();

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    try {
      const urlStr = typeof input === 'string' || input instanceof URL ? input.toString() : input.url;

      // Only attach for our API requests; leave others untouched
      if (apiBase && urlStr.startsWith(apiBase)) {
        // Skip health endpoint
        if (!urlStr.includes('/health')) {
          const authHeaders = await getAuthHeaders();

          // Merge headers
          const mergedInit: RequestInit = { ...(init || {}) };
          const existing = new Headers((init && init.headers) || (typeof input === 'object' && 'headers' in input ? (input as Request).headers : undefined));
          Object.entries(authHeaders).forEach(([k, v]) => existing.set(k, v));

          // If input is a Request, clone it with new headers
          if (input instanceof Request) {
            const req = input as Request;
            const cloned = new Request(req, { headers: existing });
            return originalFetch(cloned, mergedInit);
          }

          mergedInit.headers = existing;
          return originalFetch(urlStr, mergedInit);
        }
      }
    } catch {
      // Fall through to default fetch behavior on any error
    }
    return originalFetch(input as any, init);
  };
})();

